// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__uH4yt","footer":"ModalFilter_footer__2JSDH"};